import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5507f788&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5507f788",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5507f788')) {
      api.createRecord('5507f788', component.options)
    } else {
      api.reload('5507f788', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5507f788&scoped=true&", function () {
      api.rerender('5507f788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/custom/index.vue"
export default component.exports